import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const EDIT_URL = "https://edit.huecreative.co";
export const STUDIO_EMAIL = "desi@huecreative.co";

// Toggle back to true when The Hue Edit shop launches.
export const SHOW_HUE_EDIT = false;

export const IMAGES = {
  logo: "/generated/hue-logo.svg",
  hero: "/generated/hero-interior.png",
};

export const COLLECTIONS = [
  { key: "living", label: "Living", img: "/generated/edit-living.png" },
  { key: "dining", label: "Dining", img: "/generated/edit-dining.png" },
  { key: "lighting", label: "Lighting", img: "/generated/edit-lighting.png" },
  { key: "decor", label: "Decor", img: "/generated/edit-decor.png" },
  { key: "outdoor", label: "Outdoor", img: "/generated/edit-outdoor.png" },
];

export async function submitInquiry(payload) {
  const res = await axios.post(`${API}/inquiries`, payload);
  return res.data;
}

async function fetchWithRetry(url, opts = {}, tries = 3, timeoutMs = 6000) {
  let lastErr;
  for (let i = 0; i < tries; i++) {
    try {
      const controller = new AbortController();
      const t = setTimeout(() => controller.abort(), timeoutMs);
      try {
        return await fetch(url, { ...opts, signal: controller.signal });
      } finally {
        clearTimeout(t);
      }
    } catch (e) {
      lastErr = e;
    }
  }
  throw lastErr;
}

export async function verifyInboxPasscode(passcode) {
  const res = await fetchWithRetry(`${API}/inbox/verify?token=${encodeURIComponent(passcode)}`, { method: "POST" });
  if (!res.ok) throw { response: { status: res.status } };
  return true;
}

export async function fetchInquiries(passcode) {
  const res = await fetchWithRetry(`${API}/inquiries?token=${encodeURIComponent(passcode)}`);
  if (!res.ok) throw { response: { status: res.status } };
  return res.json();
}
